<template>
    <div class="contaner">
    <div v-if="UserType==1">
         <h2>我的工作台</h2>
     <div class="hr"></div>
     <div class="contaner-top">
         <Row>
             <Col span="3" class="left-col"><img src="../assets/avatar.png" alt=""></Col>
             <Col span="21">
             <p class="right-top"><span>早上好,{{UserInfo.Realname}}！</span>
              <img src="../assets/zhan.png" alt="" v-for="(item,index) in UserInfo.LV">
              <Button type="error" size="small" v-if="UserInfo.Status==0"><span >未完善</span></Button>
              <Button  type="error" v-if="UserInfo.Status==1"><span >未认证</span></Button>
              <Button  type="warning" v-if="UserInfo.Status==2"><span >待审核</span></Button>
              <Button  type="success" v-if="UserInfo.Status==3"><span >审核通过</span></Button></p>
              <div class="hr"></div>
             <Row class="right-bottom">
                 <Col span="4">
                    <p>账户总额</p>
                    <span>{{UserInfo.AmountSum}}</span>
                 </Col>
                  <Col span="2">
                    =
                 </Col>
                  <Col span="4">
                 <p>可提现金额</p>
                 <span>{{UserInfo.Amount}}</span>
                 </Col>
                  <Col span="2">
                    +
                 </Col>
                  <Col span="4">
                 <p>未结款项</p>
                 <span>{{UserInfo.AmountFrozen}}</span>
                 </Col>
                  <Col span="4" class="last_col">
             <Button type="info" @click="goToCashWithApply">提现</Button>
             <a href="/#/index/CapitalDetail">收支明细</a>
                 </Col>
             </Row>
             </Col>
         </Row>
     </div>
     <ul class="contaner-center">
         <li>
             <p>{{UserInfo.Amount_Total}}</p>
             <span>总收入</span>
           </li>
            <li>
             <p>{{UserInfo.UnderDevelopmentNum}}</p>
             <span>开发中项目</span>
           </li>
              <li>
             <p>{{UserInfo.BiddingNum}}</p>
             <span>竞标中</span>
           </li>
            <li>
             <p>{{UserInfo.CompleteProjectNum}}</p>
             <span>完成项目</span>
           </li>
     </ul>
     <h2 class="title2">待处理的项目动态({{pendingList.length}})</h2>
     <div class="hr"></div>
      <Table class="table" :columns="pendingListColumns" :data="pendingList"></Table>
      <h2 class="title2">
          更多项目推荐
          <!-- <a href="javascript:;" @click="goToProjectList">查看更多</a> -->
      </h2>
     <div class="hr"></div>
      <Table class="table" :columns="recommendListColumns" :data="recommendList"></Table>
    </div>
      <OverView v-else></OverView>
        <Modal
        v-model="Modal1"
      width="800"
     >
      <div slot="header" class="modal-reg-title">
            供应商认证步骤
       </div>
     <div style="height:700px;overflow:auto;"> <img src="../assets/comtent.jpg" alt=""></div>
    </Modal>
    </div>
</template>
<script>
import OverView from "@/components/Overview.vue";//特殊身份总览
export default {
    components:{
        OverView
    },
    data(){
        return{
            Modal1:true,
            Detail:{
                Name:'',
                Account:'',
                ableAmount:'0',
                Unpaid:'0',
                generalIncome:0,
                underDevelopment:0,
                Bidding:0,
                CompleteProject:0
            },
            UserType:1,//1:接包方（供应商）2:发包方；3:管理员
            UserInfo:{},
            pendingListColumns: [
                    {
                        title: '项目名称',
                        key: 'name',
                        render:(h,params)=>{
                            if (params.row.TypeID == 2) {
                                let text = '私';
                                return h('div', [
                                    h('span', {
                                        style:{
                                            backgroundColor: '#ff4d4d',
                                            color: '#fff',
                                            padding: '5px',
                                            borderRadius: '5px',
                                            marginRight: '5px',
                                            fontSize: '12px'
                                        }
                                    }, text),
                                    h('span', {
                                        style:{
                                            color:'#0198CD',
                                            fontSize:"13px"
                                        }
                                    }, params.row.Name),
                                ]);
                            } else {
                                return h('div', [
                                    h('span', {
                                        style:{
                                            color:'#0198CD',
                                            fontSize:"13px"
                                        }
                                    }, params.row.Name),
                                ]);
                            }
                        }
                    },
                    {
                        title: '项目状态',
                        key: 'status',
                        width:200,
                        align:'center',
                         render:(h,params)=>{
                             var text="竞标中"
                             if(params.row.Status==2){
                                text="开发中"
                             }
                         return h('div', [
                                h('span', {
                                    style:{
                                        color:'#0198CD',
                                        fontSize:"13px"
                                    }
                                }, text),
                            ]);
                        }
                    },
                    {
                        title: '发布时间',
                        key: 'AddTime',
                        width:200,
                        align:'center'
                    },
                    {
                        title: '备注',
                        key: 'Comment',
                        align:'center',
                        width:300
                    },
                    {
                        title: '操作',
                        key: 'address',
                        align:'center',
                        width:200,
                        render:(h,params)=>{
                            if(params.row.PmStatus==-1){
                              return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    on:{
                                        "click":()=>{
                                            this.goToProjectDetail(params.row);
                                        }
                                    }
                                }, '参与竞标'),
                             ]);
                            }else{
                              return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    on:{
                                        "click":()=>{
                                            this.goToProjectDetail(params.row);
                                        }
                                    }
                                }, '管理项目'),
                              ]);
                            }
                        }
                    }
                ],
                recommendListColumns: [
                    {
                        title: '项目名称',
                        key: 'name',
                        render:(h,params)=>{
                            if (params.row.TypeID == 2) {
                                let text = '私';
                                return h('div', [
                                    h('span', {
                                        style:{
                                            backgroundColor: '#ff4d4d',
                                            color: '#fff',
                                            padding: '5px',
                                            borderRadius: '5px',
                                            marginRight: '5px',
                                            fontSize: '12px'
                                        }
                                    }, text),
                                    h('span', {
                                        style:{
                                            color:'#0198CD',
                                            fontSize:"13px"
                                        }
                                    }, params.row.Name),
                                ]);
                            } else {
                                return h('div', [
                                    h('span', {
                                        style:{
                                            color:'#0198CD',
                                            fontSize:"13px"
                                        }
                                    }, params.row.Name),
                                ]);
                            }
                        }
                    },
                    {
                        title: '项目状态',
                        key: 'status',
                        width:200,
                        align:'center',
                        render:(h,params)=>{
                        var text="竞标中"
                            return h('div', [
                                h('span', {
                                    style:{
                                        color:'#0198CD',
                                        fontSize:"13px"
                                    }
                                }, text),
                            ]);
                        }
                    },
                    {
                        title: '发布时间',
                        key: 'AddTime',
                        width:200,
                        align:'center'
                    },
                     {
                        title: '备注',
                        key: 'Comment',
                        align:'center',
                        width:300
                    },
                     {
                        title: '操作',
                        key: 'address',
                        align:'center',
                        width:200,
                        render:(h,params)=>{
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    on:{
                                        "click":()=>{
                                            this.goToProjectDetail(params.row);
                                        }
                                    }
                                }, '参与竞标'),
                            ]);
                        }
                    }
                ],
                pendingList: [],
                recommendList: []
        }
    },
    mounted(){
       	if(this.$getLS('AdminInfo')){
            this.UserInfo=JSON.parse(this.$getLS('AdminInfo'));
            //    console.log(this.UserInfo.Status)
            this.UserType=JSON.parse(this.$getLS('AdminInfo')).Type
        }
        this.init();
    },
    methods:{
        //初始化数据
        init() {
            if (this.UserType == 1) {
                let params = {
                    MemberID : this.UserInfo.ID
                }
                //待处理项目列表
                // this.$post('api/manage.ProjectManage/getUserPendingProjectList',params).then(res=>{
                //     if (res.code == 1) {
                //         this.pendingList = res.data;
                //     }
                // });
                //推荐项目列表
                // this.$post('api/manage.ProjectManage/getUserRecommendProjectList',params).then(res=>{
                //     if (res.code == 1) {
                //         this.recommendList = res.data;
                //     }
                // });
                let params2 = {
                    'ID' : this.UserInfo.ID
                }
                // //获取用户首页数据
                // this.$post('api/manage.ProjectManage/getUserIndexData', params2).then(res=>{
                //     if (res.code == 1) {
                //         this.UserInfo = res.data;
                //     }
                // })
            }  
        },
        //前往管理页面
        goToProjectDetail(row) {
            if(row.Status==1){
                this.$router.push({path:'index/BiddingProjectDetail',query:{ID:row.ID}})
            }else{
                this.$router.push({path:'index/ProjectDetailBidding',query:{ID:row.ID}})
            }
        },
        //前往项目管理页面
        goToProjectList() {
            this.$router.push({path:'index/BiddingUserProject'})
        },
        //前往提现页面
        goToCashWithApply() {
            this.$router.push({path:'index/CashWithApply'})
        },
    }
}
</script>
<style lang="less" scoped>
  .modal-reg-title{
        background-color:#F0F2F1;
        text-align: center;
        padding:20px;
        color: #AAAAAA;
        font-size: 20px;
        i{
            float: right;
            font-size: 25px;
            cursor: pointer;
        }
    }
.contaner{
    padding:30px;
    box-sizing: border-box;
 >div{
        >h2{
       color: #435365;
       font-size: 18px;
       font-weight: normal;
       padding-bottom: 10px;
    }
    .title2{
        margin-top: 30px;
         >a{
            margin-top: 5px;
            float:right;color:#0097CA;font-size:13px;
            text-decoration: underline;
        }
    }
    .contaner-top{
        background-color: #fff;
        padding:20px 0px;
        margin-top: 30px;
        box-shadow: 0px 3px 5px #D9DDE3;
        border-radius: 5px;
        .left-col{
            text-align: center;
            img{
                width: 50%;
            }
        }
        .right-top{
            color: #1789C8;
            font-size: 16px;
            margin-top: 15px;
            margin-bottom: 15px;
            display: flex;
            img{
                width:13px ;
                height: 13px;
                margin-left: 3px;
                margin-top: 3px;
            }
            button{
                margin-left: 10px;
            }

        }
        .right-bottom{
            margin-top:20px;
            .ivu-col{
                // text-align: center;
                >p{
                    color: #6A6A6A;
                    margin-bottom: 10px;
                }
                >span{
                    color: #FF8606;
                    font-size: 20px;
                }
            }
            .last_col{
                margin-top: 29px;
                display: flex;
                a{
                    color: #0197CA;
                    font-size: 13px;
                    margin-top: 15px;
                    margin-left: 10px;
                    text-decoration: underline;
                }
            }
        }
    }
    .contaner-center{
        background-color: #fff;
        padding:20px 15px;
        margin-top: 30px;
        box-shadow: 0px 3px 5px #D9DDE3;
        border-radius: 5px;
        display: flex;
        li{
            flex:1;
            border-left:2px solid #FF8000;
            padding-left:15px;
            p{
                font-size: 30px;
                color: #303944;
                margin-bottom: 10px;
            }
            span{
                color: #88929E;
            }
        }
    }
    .table{
        margin-top: 20px;
        box-shadow: 0px 3px 5px #D9DDE3;
    }
 }
  
}

</style>


// WEBPACK FOOTER //
// src/view/Overview.vue